import styled from './parcelas.module.css';
import { CiSaveDown2, CiBarcode, CiSearch } from 'react-icons/ci';
import api from '../../services/api';
import { useEffect, useState } from 'react';
import { Alerta } from '../../utils/functions';
import { LoaderBol } from '../Loader';
import { toast } from 'react-toastify';
import copy from 'copy-to-clipboard';
import Pagination from 'react-paginate';
import '../../utils/pagination.css';
import { addDays } from 'date-fns';




function Parcelas() {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;

    const [parcelas, setParcelas] = useState([]);
    const [notas, setNotas] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [pedidos, setPedidos] = useState([]);
    const [filtro, setFiltro] = useState([]);
    const [datven, setDatven] = useState('Todas');
    const [nnota, setNnota] = useState('');
    const [filnota, setFilnota] = useState(0);
    const [fildata,setFildata] = useState('0');


    const itemPerPage = 6;
    const [currentPage, setCurrentPage] = useState(0);

    //Logica para Paginação
    const pages = (Math.ceil(notas.length / itemPerPage));
    const startIndex = currentPage * itemPerPage;
    const endtIndex = startIndex + itemPerPage;

    const currentItens = (notas.slice(startIndex, endtIndex));

    const PageClick = (event) => {
        setCurrentPage(event.selected);
    };



    function FiltraNota() {
        setFilnota(nnota);
    }



    function copytoClipboar(data) {
        copy(data);
    }

    function Barras(wnumnot, wnumpar, wsitua) {
        if (wsitua == 'VENCIDO') {
            Alerta('Informação', 'Boleto vencido! Entre em contato com o financeiro (17)99123-6900 para atualização do boleto !!', 'info');
        } else {

            api.get(`boletos/linha?cgccli=${cgccli}&numnot=${wnumnot}&numpar=${wnumpar}`)
                .then((response) => {
                    copytoClipboar(response.data.linha);
                    toast.success('Código de barras copiado!');
                }).catch((erro) => {
                    Alerta('Erro', erro, 'Error');
                })
        }

    }


    async function GetParcelas() {
        let temp = [];
        let nota = [];
        let notasfim = [];
        let datas = [];

        setLoading(true);

        await api.get(`boletos/listaabertos?cgccli=${cgccli}&datven=${datven}&numnot=${nnota}&fildata=${fildata}`)
            .then((response) => {
                if (!response.data.msg) {
                    temp = response.data;
                    temp.map((item) => {
                        if (nota.indexOf(item.numfat) < 0) {
                            nota.push(
                                item.numfat
                            )
                        }
                    })

                    nota.map((item) => {
                        notasfim.push({
                            numfat: item

                        })
                    })

                    temp.map((data) => {
                        if (datas.indexOf(data.vencto) < 0 && data.datpag == '01/01/1900') {
                            datas.push({
                                datven: data.vencto
                            })
                        }
                    })

                    setNotas(notasfim);
                    setParcelas(response.data);
                    setFiltro(datas);
                    PedidosNota();

                    setLoading(false);

                } else {
                    setLoading(false);
                    Alerta('Erro', response.data.msg, 'Error');
                }

            }).catch((erro) => {

            })
    }




    function PedidosNota() {
        api.get(`boletos/pedidos?cgccli=${cgccli}`)
            .then((response) => {
                if (!response.data.msg) {
                    setPedidos(response.data);


                } else {
                    Alerta('Erro', response.data.msg, 'Error');
                }

            }).catch((erro) => {

            })
    }

    async function GetNota(wnumnot) {
        await api.get(`pedidos/nfe/?numnot=${wnumnot}`, { responseType: 'blob' })
            .then((response) => {
                if (!response.data.msg) {

                    let blob = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    let url = window.URL.createObjectURL(blob)
                    window.open(url);
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }

    async function GetBoleto(wnumnot, wnumpar, wsitua, wvencto) {
        await api.get(`boletos/geraboleto/?cgccli=${cgccli}&numnot=${wnumnot}&numpar=${wnumpar}`, { responseType: 'blob' })
            .then((response) => {
                if (!response.data.msg) {
                    if (wsitua == "VENCIDO") {
                        Alerta('Informação', 'Boleto vencido! Entre em contato com o financeiro (17) 998174-0355. para atualização do boleto !!', 'info');
                    } else {
                        let blob = new Blob([response.data], {
                            type: 'application/pdf'
                        });
                        let url = window.URL.createObjectURL(blob)
                        window.open(url);
                    }
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }

    useEffect(() => {
        GetParcelas();
        setCurrentPage(0);
        setNnota('');
    }, [datven, filnota,fildata])


    return (
        /*Aqui laço de notas*/
        <>
            <div className={styled.headerfiltro}>
                <div className={styled.divfiltro}>
                    <div className={styled.divfiltrocontent}>
                        <a>FILTRAR POR DATA DE VENCIMENTO</a>
                        <div className={styled.divselect}>
                            <select value={datven} onChange={(e) => setDatven(e.target.value)}>
                                <option value="Todas">Todas</option>
                                <option value="Vencidos">Vencidos</option>
                                <option value="À Vencer">À Vencer</option>
                                {filtro.map((data) => {
                                    return (
                                        <option value={data.datven}>{data.datven}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={styled.divfiltro}>
                    <div className={styled.divfiltrocontent}>
                        <a>FILTRAR POR Nº NOTA FISCAL</a>
                        <div className={styled.input1}>
                            <input type="text" placeholder='Nº NOTA FISCAL' value={nnota} onChange={(e) => setNnota(e.target.value)} />
                            <CiSearch onClick={() => FiltraNota()} className={styled.divfiltro1icon} />
                        </div>
                    </div>
                </div>
                <div className={styled.divfiltro}>
                    <div className={styled.divfiltrocontent}>
                        <a>EXIBIR FINANCEIRO DE</a>
                        <div className={styled.divselect}>
                            <select name="data" id="data" value={fildata} onChange={(e)=>setFildata(e.target.value)}>
                                <option value="0">Até 1 ano atrás</option>
                                <option value="1">Até 2 anos atrás</option>
                                <option value="2">Até 3 anos atrás</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styled.contentparcela}>
                {isLoading == true ? <LoaderBol /> : <>

                    {
                        currentItens.map((nota) => {
                            return (
                                <div key={nota.numfat} className={styled.appparcela}>
                                    <div className={styled.frame100}>
                                        <div className={styled.frame100header}>
                                            <div className={styled.frame100headernota}>

                                                <a>NOTA FISCAL</a>
                                                <span>{nota.numfat}</span>

                                            </div>
                                            <div onClick={() => GetNota(nota.numfat)} className={styled.divbtn}>
                                                <CiSaveDown2 size={16} />
                                                {window.screen.availWidth >= 1024 ? <a>BAIXAR NOTA FISCAL</a> : <a>BAIXAR</a>}

                                            </div>
                                        </div>
                                        <div className={styled.framecontent}>
                                            <div className={styled.framecontentheader}>
                                                <a>PEDIDOS </a>
                                                <div className={styled.framepedidosdiv}>
                                                    <div className={styled.framepedidos}>
                                                        {pedidos.filter(pedido => pedido.numfat == nota.numfat).map((pedido) => {
                                                            return (

                                                                <a>#{pedido.numped}</a>

                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                            {/*Aqui laço das parcelas aberto*************************/}
                                            {parcelas.filter(parc => parc.numfat == nota.numfat).map((parcela) => {
                                                return (
                                                    < div key={parcela.numpar} className={styled.frameparcelasaberto}>
                                                        <div className={styled.frameparcelasaberto0}>
                                                            <a>Parcela {parcela.numpar} {parcela.tipo == 'SEM REGISTRO' ? '(SEM REGISTRO)' : null} </a>



                                                            {parcela.situa == 'A VENCER' ?
                                                                <span>VENC. {parcela.vencto}</span> : null}

                                                               
                                                            {parcela.situa == 'VENCIDO' ?
                                                                <p className={styled.vencido}>VENC. {parcela.vencto}</p> : null}

                                                            {parcela.situa == 'LIMITE' ?
                                                                <p className={styled.vencido}>VENC. {parcela.vencto}</p> : null}    

                                                            {parcela.situa == 'PAGO' ?
                                                                <span>VENC. {parcela.vencto}</span> : null}

                                                        </div>
                                                        <div className={styled.frameparcelasaberto1}>
                                                            <span>{parcela.valpar.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>

                                                            {parcela.datpag == '01/01/1900' ? <>
                                                                <div onClick={() => GetBoleto(parcela.numfat, parcela.parcela, parcela.situa,parcela.vencto)} className={styled.btnboleto}>Boleto</div>
                                                                <CiBarcode onClick={() => Barras(parcela.numfat, parcela.parcela, parcela.situa)} className={styled.btnbarras} />
                                                            </>
                                                                : <div className={styled.btnpago}>Pago : {parcela.datpag}</div>}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                            {/********************************************************/}
                                            {/* <ParcelasPagas nota={nota.numfat} />*/}
                                        </div>
                                    </div>

                                </div >
                            )
                        })
                    }

                </>

                }
            </div>
            < div className={styled.paginate}>
                <Pagination
                    breakLabel="..."
                    nextLabel=">>"
                    onPageChange={PageClick}
                    pageCount={pages}
                    previousLabel="<<"
                    renderOnZeroPageCount={null}
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                    forcePage={currentPage}
                />
            </div>
        </>
    )
}


export default Parcelas;